var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500" },
      model: {
        value: _vm.showDialog,
        callback: function($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog"
      }
    },
    [
      _c("div", {
        attrs: { tabindex: "0" },
        on: {
          keydown: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
          }
        }
      }),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-card-title", { staticClass: "headline primary--text" }, [
                _vm._v("Relatório via e-mail")
              ]),
              _c("v-spacer"),
              _c(
                "v-form",
                {
                  ref: "formEmail",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  },
                  model: {
                    value: _vm.validEmail,
                    callback: function($$v) {
                      _vm.validEmail = $$v
                    },
                    expression: "validEmail"
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      "prepend-icon": "person",
                      name: "email",
                      label: "E-mail",
                      type: "email",
                      rules: _vm.emailRules,
                      required: "",
                      "data-cy": "emailFieldforReport"
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.exportarEmailSQS()
                      }
                    },
                    model: {
                      value: _vm.emailReport,
                      callback: function($$v) {
                        _vm.emailReport = $$v
                      },
                      expression: "emailReport"
                    }
                  })
                ],
                1
              ),
              _c("v-card-subtitle", [
                _vm._v("Digite o e-mail onde deseja receber o relatório")
              ])
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.validEmail,
                    "data-cy": "btnSubmitReport"
                  },
                  on: {
                    click: function($event) {
                      return _vm.exportarEmailSQS()
                    }
                  }
                },
                [
                  _vm._v(" Enviar "),
                  _c("v-icon", { staticClass: "ml-1" }, [
                    _vm._v("chevron_right")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }